import React from 'react';

interface ControlItemProps {
  title: string;
  icon: string;
  count?: number;
  disabled?: boolean;
  index: number;
  onClick: (index: number) => void;
}

const ControlItem = ({ title, icon, count, disabled, onClick, index }: ControlItemProps) => (
  <button
    type="button"
    className={'gallery-controls-btn'}
    title={title}
    onClick={() => onClick(index)}
    disabled={disabled}
  >
    <span className="gallery-controls-btn-icon">
      <i className={`no-margin ${icon}`} />
    </span>
    <span className="gallery-controls-btn-label">{count}</span>
  </button>
);

export default ControlItem;
